import api from '../../plugins/api';

const acceptLead = (id) => {
  return api.post('/api/crm/leads/acceptLead', null, { params: { id } });
};

export default acceptLead;
